import CustomInputField from "@components/FormFields/CustomInputField";
import {
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger
} from "@components/ui/dropdown-menu";
import { useAuth } from "@hooks/useAuth";
import useDialog from "@hooks/useDialog";
import { useImpersonation } from "@hooks/useImpersonation";
import { Search, UserIcon, UsersIcon } from "lucide-react";
import { useState } from "react";

export function UserImpersonation() {
    const { users, impersonateUser } = useImpersonation();
    const { user } = useAuth();
    const { showErrorSnackbar, showSuccessSnackbar } = useDialog();
    const [searchQuery, setSearchQuery] = useState("");

    const filteredUsers = users.filter(user =>
        user.email?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleImpersonate = async (userId?: string) => {
        const targetId = userId
        if (!targetId) return;

        try {
            const targetUser = users.find((u) => u.id === targetId);
            if (!targetUser) return;

            await impersonateUser(targetUser);
            showSuccessSnackbar("Successfully impersonating user");
        } catch (error) {
            console.log(error)
            showErrorSnackbar("Failed to impersonate user");
        }
    };

    if (user?.system_role !== "admin") return null;

    return (
        <>
            <DropdownMenuSeparator />
            <DropdownMenuSub>
                <DropdownMenuSubTrigger>
                    <UsersIcon className="mr-2 h-4 w-4" />
                    Impersonate User
                </DropdownMenuSubTrigger>
                <DropdownMenuSubContent className="w-[300px] p-2">
                    <div className="px-2 pb-2">
                        <CustomInputField
                            placeholder="Search users..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="h-8"
                            leadingIcon={<Search className="h-4 w-4" />}
                        />
                    </div>
                    <DropdownMenuSeparator />
                    <div className="max-h-[300px] overflow-y-auto">
                        {filteredUsers.map((user) => <>
                            <DropdownMenuItem
                                key={user.id}
                                onClick={() => handleImpersonate(user.id)}
                                className="flex flex-col items-start py-2"
                            >
                                <div className="flex items-center w-full">
                                    <UserIcon className="mr-2 h-4 w-4" />
                                    <div className="flex flex-col">
                                        <span className="text-sm text-muted-foreground">{user.email}</span>
                                    </div>
                                </div>
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                        </>)}
                    </div>
                </DropdownMenuSubContent>
            </DropdownMenuSub>
        </>
    );
}